// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".results-grid-list{max-width:100%;display:grid;grid-gap:10px;gap:10px;grid-template-columns:46% 29% 25%;align-items:center}.address{word-wrap:break-word;color:var(--v-accentLight-darken2);font-weight:200}.distribution-result-icon{height:1.3em}@media (min-width:600px){.distribution-result-icon{height:2em}}", ""]);
// Exports
module.exports = exports;
